/**
 * Module dependencies.
 */

import React, { useLayoutEffect, useRef, useState } from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  children: JSX.Element;
  style?: any;
  expanded: boolean;
};

/**
 * Export `Expanded` component.
 */

export function Expanded({ children, expanded, className, style }: Props): JSX.Element {
  const ref = useRef<any>();
  const [height, setHeight] = useState<number | undefined>();

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    if (expanded) {
      setHeight(ref.current.offsetHeight);
    }
  }, [expanded]);

  return (
    <div
      className={cn('overflow-hidden transition-all duration-[250ms] ease-linear', className)}
      style={{
        ...(style ? style : {}),
        height: expanded ? height : 0,
        width: '100%'
      }}
    >
      <div ref={ref}>{children}</div>
    </div>
  );
}
